/**
 * CATEGORY_EXTRA_FILTERS
 *
 * Маппінг: slug категорії → масив додаткових полів фільтру.
 *
 * Типи полів:
 *   - type: 'select', source: 'manufacturers'
 *       Динамічно підгружає список з GET /products/manufacturers?categoryId={id}
 *
 * Щоб додати фільтри для нової категорії — просто додай новий ключ.
 */
export const CATEGORY_EXTRA_FILTERS = {
  'kompresory-kondytsionera': [
    {
      key: 'manufacturer',
      label: 'Виробник',
      type: 'select',
      source: 'manufacturers',
      placeholder: 'Усі виробники',
    },
  ],
};

/**
 * Категорії, для яких фільтри "Марка авто" і "Модель авто" не показуються.
 * Додай slug категорії, якщо вона не прив'язана до конкретного авто.
 */
export const CATEGORIES_WITHOUT_BRAND_MODEL = new Set([
  'kompresory-kondytsionera',
]);

/**
 * Категорії, де показується тільки фільтр "Марка авто" (без "Модель авто").
 * API-запит іде з brandId без modelId — бекенд повертає всі товари бренду
 * через findByModel_Brand_Id(brandId).
 * Використовується для категорій де всі товари прив'язані до моделі "Інші".
 */
export const CATEGORIES_BRAND_ONLY = new Set([
  'blok-upravlinnia-dvyhuna',
]);

/**
 * CATEGORY_SEO
 *
 * Маппінг: slug категорії → SEO-налаштування.
 *   - synonyms: рядок що додається до <title> в дужках (синоніми / скорочення)
 *   - h1Prefix: якщо задано — використовується замість categoryName в H1
 *
 * Щоб додати нову категорію — додай новий ключ зі slug.
 */
export const CATEGORY_SEO = {
  'avtomatychni-korobky-peredach': {
    synonyms: 'АКПП, коробка автомат',
  },

  'kompresory-kondytsionera': {
    synonyms: 'AC компресор, насос кондиціонера',
  },

  'blok-upravlinnia-dvyhuna': {
    synonyms: 'ЕБУ, блок керування, блок управління двигуна',
  },
};
